import { render, staticRenderFns } from "./SampleA.vue?vue&type=template&id=05bf67d8&scoped=true&"
import script from "./SampleA.vue?vue&type=script&lang=js&"
export * from "./SampleA.vue?vue&type=script&lang=js&"
import style0 from "./SampleA.vue?vue&type=style&index=0&id=05bf67d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf67d8",
  null
  
)

export default component.exports